import * as React from 'react';
/**
 *
 * Original name: follow
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=6364%3A2
 *
 */
export const FollowLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18.378 17.5c.082-.64.122-1.307.122-2 0-3.056-.776-5.628-2.574-7.426C14.128 6.276 11.556 5.5 8.5 5.5c-.693 0-1.36.04-2 .122v1.514C7.122 7.046 7.79 7 8.5 7c2.82 0 4.945.715 6.365 2.135S17 12.68 17 15.5c0 .71-.045 1.378-.136 2h1.514Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M14.275 17.5c.15-.603.225-1.27.225-2 0-3.869-2.131-6-6-6-.73 0-1.397.076-2 .225v1.559c.568-.19 1.234-.284 2-.284 3.028 0 4.5 1.472 4.5 4.5 0 .766-.094 1.432-.284 2h1.56Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M6.514 15.5A1.78 1.78 0 0 1 8.5 13.514a1.78 1.78 0 0 1 1.986 1.986A1.78 1.78 0 0 1 8.5 17.486 1.78 1.78 0 0 1 6.514 15.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
